/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { BookingsCountResponse } from '../../models/bookings-count-response';

export interface BookingControllerCount$Params {
}

export function bookingControllerCount(http: HttpClient, rootUrl: string, params?: BookingControllerCount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingsCountResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerCount.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: BookingsCountResponse;
      }>;
    })
  );
}

bookingControllerCount.PATH = '/booking/count';
